<div class="tw-flex tw-items-end tw-flex-col tw-px-2">
    <p>{{ data.message }}</p>
    <div *ngIf="data?.type === 'success'">
        <span class="tw-underline tw-cursor-pointer" (click)="handleShowCase()">{{ 'cases.commons.see_case' | translate }}</span> - 
        <span class="tw-underline tw-cursor-pointer" (click)="handleCopyURL()">{{ 'cases.commons.copy_url' | translate }}</span>
    </div>
</div>